import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomePage from "@/pages/Home";
import ServicesPage from "@/pages/ServicesPage";
import DefencePage from "@/pages/DefencePage";
import ProjectsPage from "@/pages/ProjectsPage";
import VideosPage from "@/pages/VideosPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";


const ScrollToTop = () => {

  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname === "/immersive") {
      window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
      requestAnimationFrame(() => {
        document.getElementById("immersive")?.scrollIntoView({ behavior: "smooth" });
      });
    } else if (pathname === "/virtual-productions") {
      window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
      requestAnimationFrame(() => {
        document.getElementById("virtual-productions")?.scrollIntoView({ behavior: "smooth" });
      });
    } else {
      window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    }
  }, [pathname]);
  return null;
};


document.addEventListener('keydown', function (e) {

  if (e.key === 'F12') {
    e.preventDefault();
  }

  if ((e.ctrlKey || e.metaKey) && e.shiftKey && ['i', 'j'].includes(e.key.toLowerCase())) {
    e.preventDefault();
  }

  if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'u') {
    e.preventDefault();
  }


  if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'r') {
    e.preventDefault();
  }
});


// Disable right-click
document.addEventListener('contextmenu', (e) => e.preventDefault());

document.addEventListener('selectstart', function (e) {
  e.preventDefault();
});


function App() {

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/immersive" element={<HomePage />} />
          <Route path="/virtual-productions" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/defence" element={<DefencePage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/videos" element={<VideosPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
        <Footer />
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#0a0a0a",
              border: "1px solid #40E0D0",
              color: "#fff",
              borderRadius: 0,
              fontFamily: "JetBrains Mono, monospace",
              fontSize: "11px",
              textTransform: "uppercase",
              letterSpacing: "0.15em",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}


export default App;
